export default "__VITE_ASSET__Csml1C$g__"